/**
 * Adiamento de um aviso dispensável: "não mostre de novo por um tempo".
 *
 * Existe porque "dispensar" tem dois sentidos, e o errado é o mais fácil de
 * escrever. Um aviso que some **para sempre** no primeiro toque deixa de cumprir
 * o papel justamente com quem mais precisa dele — quem fechou sem ler. Um que
 * não some nunca vira ruído e para de ser lido. O meio-termo é adiar: o aviso
 * volta depois de `durationMs`, enquanto a condição que o motiva continuar de pé.
 *
 * Puro de propósito: recebe o instante de agora em vez de ler o relógio, para
 * que o teste não dependa de quando roda.
 */

/** Um dia, o adiamento padrão dos avisos que convidam a uma ação. */
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Diz se um aviso dispensado em `snoozedAt` ainda deve ficar escondido em `now`.
 *
 * `snoozedAt` no **futuro** não adia nada: é relógio do aparelho que andou para
 * trás (ou valor corrompido no storage). Tratá-lo como adiamento esconderia o
 * aviso por um prazo que ninguém escolheu — e, no pior caso, para sempre.
 */
export function isSnoozed(snoozedAt: number | null, now: number, durationMs: number): boolean {
  if (snoozedAt === null || !Number.isFinite(snoozedAt)) return false;
  if (snoozedAt > now) return false;

  return now - snoozedAt < durationMs;
}
